import ReactGA from 'react-ga';

const TrackEvent = (category, action, label, value = null) => {
  ReactGA.event({
    category,
    action,
    label,
    value: Number(value)
  });
};

export default TrackEvent;